import React from "react";

import { observer } from "mobx-react";

import { useStores } from "../../contexts/StoreContext";
import CustomPage from "../CustomPage/CustomPage";

function StaticHomepage() {
  const { homepageStore } = useStores();
  const { homepage } = homepageStore;
  if (!homepage) {
    return null;
  }

  return <CustomPage pageAttributes={homepage} />;
}

export default observer(StaticHomepage);
